import { render, staticRenderFns } from "./FileUploadMenu.vue?vue&type=template&id=1b2deaf6&scoped=true&"
import script from "./FileUploadMenu.vue?vue&type=script&lang=js&"
export * from "./FileUploadMenu.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadMenu.vue?vue&type=style&index=0&id=1b2deaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2deaf6",
  null
  
)

export default component.exports